import format from "date-fns/format";
import parseISO from "date-fns/parseISO";
import { UserInvoice } from "@providers/profile/ProfileProvider.model";
import { Shopify } from "@models/shopify.model";
import { formatPrice, MoneyUnit } from "@utils/pricing";
import { PaymentListProps } from "./PaymentHistory.model";
import { AccountHeader, GeneralDisclaimer, NoResults, PaymentTable } from "../Account.styled";

const OrderItem = ({
  order,
  toggleOrderDetails,
}: {
  order: Shopify.Order;
  toggleOrderDetails: (order: Shopify.Order | null) => void;
}) => {
  let price = formatPrice(parseFloat(order.totalPrice.amount));

  return (
    <tr>
      <td>
        Order #
        <button
          aria-label="View order details"
          onClick={() => {
            toggleOrderDetails(order);
          }}>
          {order.orderNumber}
        </button>
      </td>
      <td>{format(parseISO(order.processedAt), "MM/dd/yyyy")}</td>
      <td>{price}</td>
    </tr>
  );
};

const InvoiceItem = ({ invoice }: { invoice: UserInvoice }) => (
  <tr>
    <td data-id={invoice.id}>Mirror Subscription</td>
    <td>{format(parseISO(invoice.created_at), "MM/dd/yyyy")}</td>
    <td>{formatPrice(invoice.total, MoneyUnit.CENT)}</td>
  </tr>
);

const PaymentList = ({
  isDigital,
  digitalDisclaimer,
  invoices = [],
  orders = [],
  toggleOrderDetails,
}: PaymentListProps) => {
  const noPayments = invoices.length === 0 && orders.length === 0;

  return (
    <>
      <AccountHeader>
        <h3>Payment History</h3>
      </AccountHeader>
      {isDigital && digitalDisclaimer && <GeneralDisclaimer>{digitalDisclaimer}</GeneralDisclaimer>}
      <article>
        {!noPayments ? (
          <PaymentTable>
            <thead>
              <tr>
                <th>Description</th>
                <th>Date</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              {invoices.length > 0 &&
                invoices.map((invoice) => <InvoiceItem key={invoice.id} invoice={invoice} />)}
              {orders.length > 0 &&
                orders.map((order) => (
                  <OrderItem key={order.id} order={order} toggleOrderDetails={toggleOrderDetails} />
                ))}
            </tbody>
          </PaymentTable>
        ) : (
          <NoResults>No payments found.</NoResults>
        )}
      </article>
    </>
  );
};

export default PaymentList;
